export default "__VITE_PUBLIC_ASSET__cff745a9__"